/**
 * Closes the WordPress core Navigation overlay (mobile menu) when a link
 * inside it is clicked.
 *
 * Problem: WP closes the overlay automatically only when the click leads to a
 * page load. Internal anchor links (href="#section") scroll within the same
 * page without reloading, so the overlay stays open. This handler always
 * closes the menu by triggering the block's own close button.
 */
document.addEventListener('DOMContentLoaded', () => {
	const OPEN_SELECTOR = '.wp-block-navigation__responsive-container.is-menu-open';
	const CLOSE_SELECTOR = '.wp-block-navigation__responsive-container-close';

	document.addEventListener('click', (event) => {
		const link = event.target.closest('a');
		if (!link) return;

		// Only act when the link sits inside an opened navigation overlay.
		const openOverlay = link.closest(OPEN_SELECTOR);
		if (!openOverlay) return;

		const closeButton = openOverlay.querySelector(CLOSE_SELECTOR);
		if (!closeButton) return;

		// Let the navigation/scroll happen first, then close the overlay.
		// A small delay avoids interfering with the link's own click handling.
		setTimeout(() => closeButton.click(), 50);
	});
});
